import React, { useState } from 'react'
import { Box } from '@mui/system'
import { Dialog,} from '@mui/material'
import TimeUtils from '../../utils/TimeUtils';
import { useRef, useEffect } from 'react';
import { SessionService } from '../../services/DataService';
import { DailyReport } from "../../components/Patient/DailyReport";
import CircularProgress from '@mui/material/CircularProgress';
import html2pdf from "html2pdf.js/dist/html2pdf.min";
import AlertBox from '../AlertBox';
import {  translate } from 'react-i18nify';
import { downloadReportData } from './Datatab';
import { generateChartData } from './GenerateReport';



export const DayDataDialog = (props) => {

    const DetailDialogContainerRef = useRef(null);
    const date = props.date;
    const patientId = props.patientId;
    const [reportData, setReportData] = useState(null);
    const [width, setWidth] = useState(300);
    const [chartLoading, setChartLoading] = useState(true);
    const [xaxisRange, setXaxisrange] = useState("all");
    const [chartData, setChartData] = useState([]);
    const [noDetailedData, setNoDetailedData] = useState(false)

    const [alertBox, setAlertBox] = useState({
        "visiblity": false,
        "statusCode": null,
        "text": null,
        "error": null
    }
    );


    const handleAlertBox = (visiblity, statusCode, text, error) => {
        setAlertBox({
            "visiblity": visiblity,
            "statusCode": statusCode,
            "text": text,
            "error": error
        }
        )
    }
    const dismissAlertBox=()=>{
        setAlertBox({
            "visiblity": false,
            "statusCode": null,
            "text": null,
            "error": null

        })
    }

    const handleEntered = () => {
        if (DetailDialogContainerRef.current) {
            setWidth(DetailDialogContainerRef.current.clientWidth);
        }
    };

    const getDetailedSessionsByPatientId = () => {
        // setChartLoading(true)
        var from = TimeUtils.getBeginningOfDay(date); // added
        var to = TimeUtils.getEndingOfDay(date); // added
        SessionService.getDetailedSessionsByPatientId(
            patientId,
            TimeUtils.localToUtc(from),
            TimeUtils.localToUtc(to)
        ).then((response) => {
            if(response.data === null){
                setChartLoading(false)
                setNoDetailedData(true)
                return
            }
            const orderedData = response.data.sort((a, b) => new Date(a.start) - new Date(b.start));
            const data = generateChartData(orderedData)
            setChartData(data)
            setChartLoading(false)
            // setDetailedSessions(response.data);  
        }).catch((error) => {
            console.error("Error getting detailed sessions", error); //add alert box
            handleAlertBox(true, error.response.status, translate("NoDetailedSessionData"), null)
            setChartLoading(false)
            setNoDetailedData(true)
        })

    }
    useEffect(() => {
        setChartData([]);
        setNoDetailedData(false)
        setChartLoading(true)
        if(props.open){
            (async () => {
                const from = TimeUtils.getBeginningOfDay(date)
                const to = TimeUtils.getEndingOfDay(date)
                const reportData = await downloadReportData(patientId, date.toISOString(), from, to, true)
                .catch((error) => {
                    console.error("Error getting report data:", error.response.data);
                    handleAlertBox(true, error.response.status, translate("NoDetailedSessionData"), null)
                    setChartLoading(false)
                    setNoDetailedData(true)
                });
                setReportData(reportData);
              })();    
            getDetailedSessionsByPatientId(patientId, date, date)
        }
    }, [props.open])

    if (!props.open) {
        return null;
    }

    return (

        <Dialog
            fullWidth
            maxWidth="md"
            sx={{ width: "100%", p: 0 }}
            open={props.open}
            onClose={() => { props.onClose() }}
            TransitionProps={{ onEntered: handleEntered }}
        >
            <Box sx={{ p: 2 }}>
                {
                    chartLoading ? 
                    
                    <Box sx={{ display: 'flex', justifyContent: 'center', height:"250px", alignItems: 'center' }}>
                        <CircularProgress />
                    </Box> :

                    noDetailedData ?
                    <Box sx={{width: "max-content"}} >
                        <AlertBox 
                            visible={alertBox.visiblity} 
                            error={alertBox.error}
                            text={alertBox.text}
                            statusCode={alertBox.statusCode}
                        />
                    </Box>
                    :
                    <DailyReport
                        open={true}
                        chartData={chartData}
                        reportData={reportData}
                        date={date}
                        data={reportData}
                    ></DailyReport>
                }
                

            </Box>
        </Dialog >
    )
}
